module.exports = __webpack_public_path__ + "static/media/sketch2.1762d592.jpg";